import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { HeaderBannerProps } from '..';

const useStyles = makeStyles({ name: 'MobileHeaderBanner' })(({ Skoda: { settings: { headerBanner } } }) => ({
	imageContainer: {
		position: 'relative',
		overflow: 'hidden'
	},
	image: {
		width: '100%',
		height: 'auto'
	},
	rectangle: {
		background: headerBanner.color,
		paddingBottom: 42
	},
	gradient: {
		position: 'absolute',
		left: 0,
		top: 0,
		right: 0,
		bottom: 0,
		background: `linear-gradient(180deg, rgba(0, 0, 0, 0) 60.42%, ${headerBanner.color} 99%)`
	},
	root: {

	}
}));

export const MobileHeaderBanner: React.FC<HeaderBannerProps> = (props) => {
	const { children, img, onImageLoad } = props;
	const { classes: styles } = useStyles(undefined, { props });

	const handleImageOnLoad = () => {
		if (onImageLoad) onImageLoad();
	};

	const images: string[] = typeof (img) === 'string' ? [img] : img;
	const [defaultImg, ...other] = images;

	return (
		<div data-test='header-banner-mobile' className={styles.root}>
			<div className={styles.imageContainer}>
				<picture>
					{other.map(anotherFormatImage =>
						<source srcSet={anotherFormatImage} type={`image/${anotherFormatImage.split('.').pop()}`} />)}
					<img width={1152} height={780} className={styles.image} src={defaultImg} alt='banner' onLoad={handleImageOnLoad} />
				</picture>
				<div className={styles.gradient} />
			</div>
			<div className={styles.rectangle}>
				{children}
			</div>
		</div>
	);
};
